/**
 * 이미지 편집기 (/image-editor/{id}) — 서류함·관리자 서류목록이 FullFrame 으로 띄운다($j.F.ImageEditor.open).
 * 편집기 본체는 $j.F.ImageEditor (TUI). 여기서는 이미지 주소(#page-data)를 넘겨 띄우고 [닫기] 를 잇는다.
 */
export default class ImageEditor {
    initialize() {
        const d = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        $('#ed-close').on('click', () => $j.F.ImageEditor.close());
        // 이미지가 없으면 편집기를 띄우지 않는다 — TUI 는 빈 경로를 받으면
        // 캔버스만 검게 남기고 아무 말도 하지 않는다. 안내는 blade 의 .ed-noimg 가 한다.
        if (!d.imgUrl) return;
        $j.F.ImageEditor.init({ imgUrl: d.imgUrl });
    }
}
